var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.1375C11.6808 19.1375 11.4115 19.0278 11.1919 18.8082C10.9723 18.5886 10.8625 18.3192 10.8625 18V13.1375H6.00005C5.68085 13.1375 5.41147 13.0278 5.1919 12.8082C4.97233 12.5886 4.86255 12.3192 4.86255 12C4.86255 11.6808 4.97233 11.4115 5.1919 11.1919C5.41147 10.9723 5.68085 10.8625 6.00005 10.8625H10.8625V6.00005C10.8625 5.68085 10.9723 5.41147 11.1919 5.1919C11.4115 4.97233 11.6808 4.86255 12 4.86255C12.3192 4.86255 12.5886 4.97233 12.8082 5.1919C13.0278 5.41147 13.1375 5.68085 13.1375 6.00005V10.8625H18C18.3192 10.8625 18.5886 10.9723 18.8082 11.1919C19.0278 11.4115 19.1375 11.6808 19.1375 12C19.1375 12.3192 19.0278 12.5886 18.8082 12.8082C18.5886 13.0278 18.3192 13.1375 18 13.1375H13.1375V18C13.1375 18.3192 13.0278 18.5886 12.8082 18.8082C12.5886 19.0278 12.3192 19.1375 12 19.1375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSmall);
export default __webpack_public_path__ + "static/media/plus-small.1aeb89ae1aedd5ad5bdaaa4bf138373b.svg";
export { ForwardRef as ReactComponent };